const drawerFactory = require('components/ui/drawer/js/main');
const insuranceContentFactory = require('components/insurances/insurance_content/js/main');
const DRAWER_TRACKING_ACTION = 'ancillary_information';
const DYNPACK_PRODUCT = 'dp';
const FLIGHTS_PRODUCT = 'fl';
const PAGES_TO_TRACK = {
    results: 'res',
    details: 'pax',
    flightsummary: 'sum',
    flightinfo: 'info',
    payment: 'pay',
};
const trackingUtils = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/tracking.utils');
const getFlowStep = () => {
    const page = Odigeo.History.getPageNameFromFragment();
    const productPageIdentifier = getProductPageIdentifier();
    return PAGES_TO_TRACK[page] + productPageIdentifier;
};
const getProductPageIdentifier = () => {
    return Odigeo.Utils.isRequestApp(DYNPACK_PRODUCT) ? DYNPACK_PRODUCT : FLIGHTS_PRODUCT;
};

const trackClosingDrawer = () => {
    const step = getFlowStep();
    trackingUtils.trackEvent(DRAWER_TRACKING_ACTION, `ancillary_close_details_cat:HUB_pag:${step}`);
};

module.exports = {
    create({model}) {
        return drawerFactory.create({
            id: `drawer-flight-insurance-information`,
            contentFactory: insuranceContentFactory,
            size: '-lg',
            position: '-right',
            onCloseDrawer: trackClosingDrawer,
            model,
        });
    },
};
